import comLeaveWord from '../../components/com-leave-word.vue';
import comRichtext from '@/components/com-richtext.vue';
export default{
    name:'ProductDetail',
    data(){
        return{
            dialogVisible:false,
            detail:{},
            source:'CPZX',
            chatId:''
        }
    },
    mounted(){
        this.chatId=this.$route.query.id;
        this.getData();
    },
    components:{
        comLeaveWord,
        comRichtext,
    },
    methods:{
        getData(){
            var body={
                id:this.chatId,
            };
            this.get(this.api.getProductCenterDetail,body).then(res=>{
                if(res.result==200){
                    this.detail=res.data;
                }
            }).catch();
        }
    }
}